import React, {useEffect, useState} from "react";
import { useParams } from 'react-router-dom';
import axios from "axios";
import { apiUrl, assetsUrl } from "../../config/config";
import { Link } from "react-router-dom";
import Overlay from '../../components/Overlay';
import Spinner from "react-activity/dist/Spinner";
import { getRoundedDiscountAmount, getRoundedDiscountPercent, getRoundedSellingPrice, roundNumber } from "../../utils/price";

const NewReleaseHindi = () => {
    const { link } = useParams();
    const [showloding, setshowloding] = useState(false);
    const [offersdata, setoffersdata] = useState([]);
    // console.log('offer link >>', link);

    const fetchdashboarddata = async(id) => {
        setshowloding(true);
        var data = {
            name: 'New Release - Hindi'
        };
        const headers = {
            headers: {
              "Content-Type": "application/json",
            },
          };

          let resp = await axios
          .post(apiUrl + "hometabproducts",data, headers)
          .then((res) => {
            // console.log('res >>', res.data)
            setoffersdata(res.data.data);
           })
           .catch((err) => {
            alert(err.message);
          });
        setshowloding(false);
    }

    useEffect(() => {
        fetchdashboarddata(link);
      }, [link])
    
    return (
      <section className="pd50">
        <div className="container">
          <div className="row">
            {
              offersdata?.length > 0 ?
              offersdata?.map((item, index) => {
                // console.log('item >>', item)
                var proimage = null;
                if(item?.image1) {
                  proimage = item?.image1;
                } else if(item?.image2) {
                  proimage = item?.image2;
                } else if(item?.image3) {
                  proimage = item?.image3;
                } else if(item?.image4) {
                  proimage = item?.image4;
                } else if(item?.image5) {
                  proimage = item?.image5;
                } else if(item?.image6) {
                  proimage = item?.image6;
                } else if(item?.image7) {
                  proimage = item?.image7;
                } else if(item?.image8) {
                  proimage = item?.image8;
                } else {
                  proimage = null;
                }

                //percent
                var discountpercent = getRoundedDiscountPercent(item?.discount_percent);
                var price = item?.price;
                var discountprice = discountpercent > 0 ? getRoundedDiscountAmount(price, discountpercent) : 0;
                var sellingprice = getRoundedSellingPrice(price, discountpercent);
                var originalprice = roundNumber(price);
                return (
                  <div className="col-md-3" key={index}>
                  <Link to={`/entertainment/${item?.slug}`} style={{cursor: 'pointer'}}>
                    <div className="card-img">
                      <div className="align-items-center d-flex justify-content-center img-border">
                        <img className="img-fluid" src={assetsUrl + 'products/'+proimage} alt={item?.name || "Product"} />
                        <div className="listingsoldoutdiv">
                                  {
                                    item?.stock < 1 ?
                                    <span style={{backgroundColor: '#e61513', color: '#fff', padding: 5,
                                      position: 'absolute', bottom: 0, right: 0, fontSize: 15
                                    }} >SOLD OUT</span> : null
                                  }
                                  </div>
                      </div>
                      <div className="card-img-text img-text">
                        <p class="price listing_title" style={{color: '#000'}}>
                          <span class="artist_name">{item?.composer}</span><br />
                          <span class="product_name">{item.name}</span><br />
                          <span class="formate_name">{item?.formate} </span>&nbsp;
                          <span class="product-price">₹{sellingprice}</span> 
                          {
                            discountpercent > 0 ? 
                            <span class="clr">
                            <s>₹{originalprice}</s>
                          </span> : null
                          }
                         
                          {
                            discountpercent > 0 ?
                            <span className="offer"><br />{discountpercent}% OFF</span> : null
                          }
                          
                        </p>
                        <div class="price-detail price-box">
                  {
                    discountprice > 0 ?
                    <span class="dicount-amount">Save ₹{discountprice}</span> :
                    null
                  }
                                

                                  
                                  
                                  </div>
                      </div>
                    </div>
                  </Link>
                </div>
                  
                )
              })
              : 
            
                showloding ?
                <Spinner color='#f8a41a' size={30} className='spinnerCenteroffer' /> : 
                <p class="price" style={{color: '#000'}}>
                <span class="artist_name">No Products added in this offer</span>
              </p>
            
            }
            
          </div>
        </div>
      </section>
    );
}

export default NewReleaseHindi
